module.exports = __webpack_public_path__ + "img/logo_delivery_today.06b62ef.svg";